import axios, { AxiosResponse } from 'axios';
import { Http, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/toPromise';
import { Injectable } from '@angular/core';
import { URLSearchParams } from '@angular/http';

import { environment } from '../environments/environment';
import { HttpClient } from '@angular/common/http';

// import * as crypto from 'crypto';

let HOST = environment.apiHost;

@Injectable()
export class MainService {

    constructor(private http: Http, private httpClient: HttpClient) { }

    // getProjectList(param: { user?: any; }, data?: any): Promise<any> {
    //     const params: URLSearchParams = new URLSearchParams();
    //     params.set('user', param.user);
    //     return this.http.post(HOST + '/projects', params)
    //         .toPromise()
    //         .then(response => {
    //             return response.json();
    //         })
    //         .catch(err => err);

    // }

    public passwordChange = '/updatePassword';
    // public uploadFile = '/upload';

    getWorkflow(param: {}, data?: any): Promise<any> {
        const headers = {
            'Content-Type': 'application/json'
        };

        return this.httpClient.get(HOST + '/workflow', { headers })
            .toPromise()
            .then(response => response)
            .catch(err => err);
        
    }

    getProjectList(param: { user?: any; }, data?: any): Promise<any> {
        const headers = {
            'Content-Type': 'application/json'
        };

        const requestBody = {
            user: param.user
        };

        return this.httpClient.post(HOST + '/projects', requestBody, { headers })
            .toPromise()
            .then(response => response)
            .catch(err => err);


    }

    authExternalUser(param: {us?: any; ps?: any; }, data?: any): Promise<any> {
        const headers = {
            'Content-Type': 'application/json'
        };

        const requestBody = {
            user_email: param.us,
            user_password: param.ps
        };

        console.log("authExternalUser", requestBody);

        return this.httpClient.post(HOST + '/external-user-login', requestBody, { headers })
            .toPromise()
            .then(response => response)
            .catch(err => err);

    }

    updateAuthExternalUserPassword(param: {lg?: any; cp?: any; nps?: any; rps?: any; }, data?: any): Promise<any> {
        const headers = {
            'Content-Type': 'application/json'
        };

        const requestBody = {
            lg: param.lg,
            cp: param.cp,
            nps: param.nps
        };

        return this.httpClient.post(this.passwordChange + '/update-external-user-login', requestBody, { headers })
            .toPromise()
            .then(response => response)
            .catch(err => err);

        // return this.httpClient.post(HOST + '/update-external-user-login', requestBody, { headers })
        //     .toPromise()
        //     .then(response => response)
        //     .catch(err => err);

    }

    async getReleaseComponents(param, data?: any): Promise<any> {
        const headers = {
            'Content-Type': 'application/json'
        };

        const requestBody = {
            fromdate: param.fd,
            todate: param.td,
            user: param.user
        };

        try {
            const response: AxiosResponse = await axios.post(HOST + '/release-comp', requestBody, { headers });
            return response.data;
        } catch (error) {
            return error;
        }
    }

    getComponents(param: { id?: any; list?: any; user?: any; }, data?: any): Promise<any> {
        const headers = {
            'Content-Type': 'application/json'
        };
        
        const requestBody = {
            id: param.id,
            list: param.list,
            user: param.user
        };

        return this.httpClient.post(HOST + '/components', requestBody, { headers })
            .toPromise()
            .then(response => response)
            .catch(err => err);

    }

    getUsers(param: { id?: any; role?: any; }, data?: any): Promise<any> {
        const headers = {
            'Content-Type': 'application/json'
        };

        const requestBody = {
            id: param.id,
            role: param.role
        };

        return this.httpClient.post(HOST + '/users', requestBody, { headers })
            .toPromise()
            .then(response => response)
            .catch(err => err);

        // const params: URLSearchParams = new URLSearchParams();
        // params.set('id', param.id);
        // params.set('role', param.role);

        // return this.http.post(HOST + '/users', params)
        //     .toPromise()
        //     .then(response => {
        //         return response.json();
        //     })
        //     .catch(err => err);

    }

    getReleaseBundles(param: { fd?: any; td?: any; p?: any; b?: any; user?: any; }, data?: any): Promise<any> {
        const headers = {
            'Content-Type': 'application/json'
        };

        const requestBody = {
            fd: param.fd,
            td: param.td,
            p: param.p,
            b: param.b,
            user: param.user
        };

        return this.httpClient.post(HOST + '/release-bundles', requestBody, { headers })
            .toPromise()
            .then(response => response)
            .catch(err => err);

        // const params: URLSearchParams = new URLSearchParams();
        // params.set('fd', param.fd);
        // params.set('td', param.td);
        // params.set('p', param.p);
        // params.set('b', param.b);
        // params.set('user', param.user);

        // return this.http.post(HOST + '/release-bundles', params)
        //     .toPromise()
        //     .then(response => {
        //         return response.json();
        //     })
        //     .catch(err => err);
    }



    getVersions(param: { id?: any; component?: any; editMode?: any; }, data?: any): Promise<any> {

        const headers = {
            'Content-Type': 'application/json'
        };

        const requestBody = {
            id: param.id,
            component: param.component,
            editMode: param.editMode
        };

        return this.httpClient.post(HOST + '/version', requestBody, { headers })
            .toPromise()
            .then(response => response)
            .catch(err => err);

        // const params: URLSearchParams = new URLSearchParams();
        // params.set('id', param.id);
        // params.set('component', param.component);
        // params.set('editMode', param.editMode);

        // return this.http.post(HOST + '/version', params)
        //     .toPromise()
        //     .then(response => {
        //         return response.json();
        //     })
        //     .catch(err => err);

    }

    userLogin(param: { us?: any; ps?: any; }, data?: any): Promise<any> {


        const params: URLSearchParams = new URLSearchParams();
        params.append('name', param.us);
        params.append('ps', param.ps);

        return this.http.post(HOST + '/login', params)
            .toPromise()
            .then(response => {
                return response.json();
            })
            .catch(err => err);

    }

    // MSauthLogin(param, data?: any): Promise<any> {

    // }

    async createLoginSessionInMicrosoft(param: { token?: any; }, data?: any): Promise<any>{
        const params: URLSearchParams = new URLSearchParams();
        params.append('token', param.token);
        console.log("createLoginSessionInMicrosoft");
    
        const GRAPH_API_ENDPOINT="https://graph.microsoft.com/v1.0/me";
    
        var authToken = param.token;
    
        const options = {
            headers: {
                Authorization: `Bearer ${authToken}`
            }
        };
    
        try {
            const response = await axios.get(GRAPH_API_ENDPOINT, options);
    
            console.log("response", response.data);
            const currentTimeInMilliseconds = Date.now();
            var sessionid = `${response.data.id}-${currentTimeInMilliseconds}`;
    
            var numericValue = this.stringToEncryptedNumericValue(sessionid, "sessionid");
            response.data.id = numericValue;
    
            return response.data;   
        } catch (error) {
            if (error.response && error.response.status === 401) {
                // Redirect to login-error page
                window.location.href = "http://localhost:4300/login-error";
                // window.location.href = "http://dfnrm-uat.dqtsl.dev/login-error";
            } else {
                // Handle other errors if needed
                console.error("Error:", error);
                throw error;
            }
        }
    }    

    stringToEncryptedNumericValue(inputString: string, secretKey: string, length: number = 20) {
        // Ensure secretKey is a string
        secretKey = String(secretKey);

        let encryptedValue = '';

        for (let i = 0; i < length; i++) {
            const charCode = inputString.charCodeAt(i % inputString.length);
            const secretCharCode = secretKey.charCodeAt(i % secretKey.length);
            const encryptedChar = String.fromCharCode(charCode ^ secretCharCode);
            encryptedValue += encryptedChar;
        }

        // Encode the encrypted value in base64 to make it longer and include characters
        const base64Encoded = btoa(encryptedValue);

        return base64Encoded;
    }

    async fetch(endpoint: string, accessToken: any) {
        const options = {
            headers: {
                Authorization: `Bearer ${accessToken}`
            }
        };
    
        console.log(`request made to ${endpoint} at: ` + new Date().toString());
    
        try {
            const response = await axios.get(endpoint, options);
            return await response.data;
        } catch (error) {
            throw new Error(error);
        }
    }

    PMLogin(): Promise<any> {

        // const headers = {
        //     'Content-Type': 'text/html'
        // };

        // return this.httpClient.post(HOST + '/create-PM-session', { headers })
        //     .toPromise()
        //     .then(response => response)
        //     .catch(err => err);

        const params: URLSearchParams = new URLSearchParams();

        return this.http.post(HOST + '/create-PM-session', params)
            .toPromise()
            .then(response => {
                return response.json();
            })
            .catch(err => err);

    }


    // client login 
    clientLogin(param: { us?: any; ps?: any; }, data?: any): Promise<any> {

        const params: URLSearchParams = new URLSearchParams();
        params.set('name', param.us);
        params.set('ps', param.ps);


        return this.http.post(HOST + '/client-login', params)
            .toPromise()
            .then(response => {
                return response.json();
            })
            .catch(err => err);

    }

    // getWorkflow(param: {}, data?: any): Promise<any> {

    //     return this.http.get(HOST + '/workflow')
    //         .toPromise()
    //         .then(response => {
    //             return response.json();
    //         })
    //         .catch(err => err);

    // }

   

    sendEditWorkFlow(param: { release_id?: any; workflow?: any; comment?: any; user?: any; }, data?: any): Promise<any> {

        const headers = {
            'Content-Type': 'application/json'
        };

        const requestBody = {
            release_id: param.release_id,
            workflow: param.workflow,
            comment: param.comment,
            user: param.user
        };

        return this.httpClient.post(HOST + '/edit-workflow', requestBody, { headers })
            .toPromise()
            .then(response => response)
            .catch(err => err);

        // const params: URLSearchParams = new URLSearchParams();
        // params.set('release_id', param.release_id);
        // params.set('workflow', param.workflow);
        // params.set('comment', param.comment);
        // params.set('user', param.user);

        // return this.http.post(HOST + '/edit-workflow', params)
        //     .toPromise()
        //     .then(response => {
        //         return response.json();
        //     })
        //     .catch(err => err);
    }

    sendReleaseBundle(param: { name?: any; desc?: any; project?: any; uatDate?: any; created_by?: any; qa?: any; }, data?: any): Promise<any> {
        const headers = {
            'Content-Type': 'application/json'
        };

        const requestBody = {
            name: param.name,
            desc: param.desc,
            project: param.project,
            uatDate: param.uatDate,
            created_by: param.created_by,
            qa: param.qa
        };

        return this.httpClient.post(HOST + '/add-release-bundle', requestBody, { headers })
            .toPromise()
            .then(response => response)
            .catch(err => err);

        // const params: URLSearchParams = new URLSearchParams();
        // params.set('name', param.name);
        // params.set('desc', param.desc);
        // params.set('project', param.project);
        // params.set('uatDate', param.uatDate);
        // params.set('created_by', param.created_by);
        // params.set('qa', param.qa);

        // return this.http.post(HOST + '/add-release-bundle', params)
        //     .toPromise()
        //     .then(response => {
        //         return response.json();
        //     })
        //     .catch(err => err);
    }



    getUserEmail(param: { us?: any; }, data?: any): Promise<any> {

        const params: URLSearchParams = new URLSearchParams();
        params.set('name', param.us);

        return this.http.post(HOST + '/logged_user', params)
            .toPromise()
            .then(response => {
                return response.json();
            })
            .catch(err => err);

    }

    getUserDetails(param: { username?: any; session?: any; }, data?: any): Promise<any> {

        const params: URLSearchParams = new URLSearchParams();
        params.set('username', param.username);
        params.set('session', param.session);

        return this.http.post(HOST + '/user-meta-data', params)
            .toPromise()
            .then(response => {
                return response.json();
            })
            .catch(err => err);

    }

    UpdateBundleVersionData(param: { rbd_id?: any; version?: any; rid?: any; component?: any; }, data?: any): Promise<any> {
        
        const headers = {
            'Content-Type': 'application/json'
        };

        const requestBody = {
            rbd_id: param.rbd_id,
            version: param.version,
            rid: param.rid,
            component: param.component
        };

        return this.httpClient.post(HOST + '/update-bundle-version', requestBody, { headers })
            .toPromise()
            .then(response => response)
            .catch(err => err);

        // const params: URLSearchParams = new URLSearchParams();
        // params.set('rbd_id', param.rbd_id);
        // params.set('version', param.version);
        // params.set('rid', param.rid);
        // params.set('component', param.component);

        // return this.http.post(HOST + '/update-bundle-component', params)
        //     .toPromise()
        //     .then(response => {
        //         return response.json();
        //     })
        //     .catch(err => err);

    }

}